export default __webpack_public_path__ + "static/media/five.21666117.jpg";